module.exports = __webpack_public_path__ + "img/dashboard.32ce5824.svg";